import { ActionTree } from "vuex";
import { GenericBaseParameter } from "../../../../models/base-parameter";
import { PersonServices } from "../../../../services/person.services";
import defineTypeConstants from "./person-proposals-types.store";
import {
	PersonProposalParameterModel,
	// IPersonProposalListingModel
} from "../../../../models/person";
// import { IListing } from "../../../../models/listing-base-model";
import { PersonListState } from "../states.store";

const proposalsActions = <ActionTree<PersonListState, any>>{
	// DO NOT CHECK PROPOSALS EXIT
	// BECAUSE PROPOSALS HAVE PAGINATION
	[defineTypeConstants.Get.LIST_OF_PROPOSALS]: (
		{ getters, commit },
		params: GenericBaseParameter<PersonProposalParameterModel>
	) => {
		return (getters.service as PersonServices)
			.getPersonProposals(params)
			.then((listingResult: any) => {
				return Promise.resolve(listingResult);
			})
			.catch(error => {
				return Promise.reject(error);
			});
	}
};

export default proposalsActions;
